
import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#refresh_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M12 2c2.291 0 4.454.77 6.216 2.177l1.238-1.302a.664.664 0 0 1 1.122.27l1.396 4.73a.666.666 0 0 1-.795.836l-4.794-1.156a.664.664 0 0 1-.327-1.107l1.236-1.3A8.6 8.6 0 0 0 12 3.334c-4.779 0-8.667 3.888-8.667 8.667 0 4.778 3.888 8.666 8.667 8.666s8.667-3.888 8.667-8.666A.666.666 0 1 1 22 12c0 5.514-4.486 10-10 10S2 17.515 2 12 6.486 2 12 2"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="refresh_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRefresh;
